// extracted by mini-css-extract-plugin
export default {"statsColumnItem":"StatsColumn_statsColumnItem__eYKqs"};